@use 'modules/common/assets/fonts/fonts';

body {
  margin: 0;
  font-family: 'Lexend', Tahoma, Geneva, Verdana, sans-serif;
  background: #fbfbfe;
}

* {
  box-sizing: border-box;
}
